module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dy-item-wrap', {
    attrs: {
      "item": _vm.item
    }
  }, [_c('el-select', _vm._g(_vm._b({
    attrs: {
      "clearable": typeof _vm.item.clearable == 'boolean' ? _vm.item.clearable : true,
      "filterable": _vm.item.remote || _vm.item.filterable,
      "placeholder": _vm.item.placeholder || '请选择',
      "remote": _vm.item.remote,
      "remote-method": _vm.remoteMethod,
      "disabled": _vm.item.disabled
    }
  }, 'el-select', _vm.$attrs, false), _vm.$listeners), _vm._l((_vm.item.options), function(o) {
    return _c('el-option', {
      key: o.value,
      attrs: {
        "label": o.label,
        "value": o.value,
        "disabled": o.disabled
      }
    })
  }), 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ebf4cc64"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DynamicForm/widgets/SelectWidget.vue
// module id = 730
// module chunks = 20